export const XTrashMeSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 26) * 38}
      viewBox="0 0 26 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di_279_33)">
        <rect
          x="1"
          y="1"
          width="24"
          height="36"
          rx="1"
          fill="url(#paint0_linear_279_33)"
        />
        <rect
          x="1.5"
          y="1.5"
          width="23"
          height="35"
          rx="0.5"
          stroke="white"
          strokeOpacity="0.92"
        />
      </g>
      <path
        d="M13.5 17C12.3333 17.1667 8.79428 18.6029 6 20C4 21 4.00003 24.5 1.5 27L1.49997 25C3.5 21.5 3.39723 18.9673 5.5 18.5C10 17.5 16 13.5 16.5 11.5C17 9.5 12.7343 7.91409 13.5 6C14.5 3.5 14 2.5 14 1.5H15.5C15.5 4.5 15 4 15 6C15 8.5 18 8.5 18 11C18 13 16 15.1667 15 16C15.6666 17.6667 16.2 20.6 17 21C19 22 19.5 20 22 21.5C22.8439 22.0064 22.5 23 24.5 24C24.5 26.5 24.3656 24.8575 24.5 26C22 24.5 22.2 23.8 21 23C19.5 22 17.5 23.5 16 22C14.8 20.8 13.8333 18.1667 13.5 17Z"
        fill="black"
        stroke="black"
      />
      <defs>
        <filter
          id="filter0_di_279_33"
          x="0"
          y="0"
          width="26"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_279_33"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_279_33"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_279_33"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.67 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_279_33"
          />
        </filter>
        <linearGradient
          id="paint0_linear_279_33"
          x1="13"
          y1="1"
          x2="13"
          y2="37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197C01" />
          <stop offset="0.489583" stopColor="#235F1A" />
          <stop offset="1" stopColor="#197C01" />
        </linearGradient>
      </defs>
    </svg>
  );
};
